import { AppRouter } from '@/router/AppRouter'
import { Toaster } from 'sonner'
import { QueryProvider } from '@/queries/QueryProvider'

function App() {
  return (
    <QueryProvider>
      <AppRouter />
      <Toaster position="top-right" richColors closeButton />
    </QueryProvider>
  )
}

export default App